import { render, staticRenderFns } from "./PoActivityRecordRegist.vue?vue&type=template&id=366fbe7f"
import script from "./PoActivityRecordRegist.vue?vue&type=script&lang=js"
export * from "./PoActivityRecordRegist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports